module.exports = __webpack_public_path__ + "img/sm-youtube-o.2d5d5382.svg";